import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { SocketContext } from '../../context/SocketContext'
import { useHideMenu } from '../../hooks/useHideMenu'
import { useGetPantallas } from '../../hooks/useGetPantallas'
import { getUsuarioStorage } from '../../helpers/getUsuarioStorage'

import { SelectElement } from '../../components/selectElement2'
import { SelectBuscable } from '../../components/SelectBuscable'
import LoadingOverlay from '../../components/LoadingOverlay'
import { NoAcceso } from '../../components/NoAcceso'
import { serverApi } from '../../api'
import { CrearModuloModal } from './components/CrearModuloModal'
import { GestionarModuloClasesModal } from './components/GestionarModuloClasesModal'



const MySwal = withReactContent(Swal);
const sweet = (title, html, icon) => { MySwal.fire({ title, html, icon, confirmButtonColor: 'var(--color-primario)', timer: 15000 }) }
const sweetConfirm = (title, html, icon) => {
    return MySwal.fire({

        title,
        html,
        icon,
        confirmButtonText: 'Ok',
        confirmButtonColor: 'var(--color-primario)',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
    })
}

const paginacionBtn = {
    width: 34, height: 34, borderRadius: 10, border: '1.5px solid #e2e8f0',
    background: '#ffffff', color: 'var(--color-primario-texto)', cursor: 'pointer', fontSize: 12,
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
}

const botonAccion = (bg, color) => ({
    width: 30, height: 30, borderRadius: 9, border: 'none',
    background: bg, color, cursor: 'pointer', fontSize: 12,
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    transition: 'background .15s',
})

const chipStyle = {
    background: '#f1f5f9', color: '#475569', fontWeight: 700,
    padding: '5px 11px', borderRadius: 999, fontSize: 12,
    display: 'inline-flex', alignItems: 'center', gap: 5,
    whiteSpace: 'nowrap', lineHeight: 1.4,
};

const chipOk = { background: '#d1fae5', color: '#047857' };
const chipNo = { background: '#e2e8f0', color: '#64748b' };


export const ModulosCreacion = () => {

    let [usuario] = useState(getUsuarioStorage());
    const pantallas = useGetPantallas();
    const navigate = useNavigate();
    const { socket } = useContext(SocketContext);

    useHideMenu(false);

    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showClasesModal, setShowClasesModal] = useState(false);

    const [ubicaciones, setUbicaciones] = useState([]);


    const [searchInput, setSearchInput] = useState('');

    const [query, setQuery] = useState({
        search: '',
        page: 1,
        limit: 10,
        sortBy: 'modulo',
        sortDir: 'asc',
        ideUbicacion: '',
        codigoUbicacion: '',
        nombreUbicacion: '',
    });
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const totalPages = Math.max(1, Math.ceil(total / query.limit));

    // Edición en línea del nombre del módulo
    const [editingUid, setEditingUid] = useState(null);
    const [editingNombre, setEditingNombre] = useState('');


    useEffect(() => {
        if (!usuario?.uidUsuario) navigate('/Ingreso');
    }, [usuario, navigate]);

    //Select-ubicaciones
    useEffect(() => {

        const codigoEntidad = localStorage.getItem("codigoEntidad");

        if (!codigoEntidad) return;

        const fetch = async () => {
            try {

                const resp = await serverApi.post(`/ubicaciones/select-ubicaciones`, { codigoEntidad });

                const opciones = resp.data.data.map((item) => ({ value: item.ideUbicacion, label: item.nombreUbicacion.toUpperCase(), data: item.codigoUbicacion }))
                setUbicaciones(opciones);

                const ubicacionUsuario = opciones.find(
                    u => u.data === usuario.codigoUbicacion
                );

                if (ubicacionUsuario) {
                    setQuery(prev => ({
                        ...prev,
                        ideUbicacion: ubicacionUsuario.value,
                        codigoUbicacion: ubicacionUsuario.data,
                        nombreUbicacion: ubicacionUsuario.label
                    }));
                }

            } catch (error) {
                console.error("Error al obtener clases Modulos", error);
            } finally {

            }
        };

        fetch();

    }, [usuario])

    const handleSelectUbicacion = (selected) => {

        setQuery(prev => ({
            ...prev,
            page: 1,
            ideUbicacion: selected.value,
            nombreUbicacion: selected.label,
            codigoUbicacion: selected.data
        }));
    };


    //Carga inicial de los Modulos
    useEffect(() => {
        const load = async () => {

            const codigoEntidad = usuario.codigoEntidad;
            const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
            if (!codigoEntidad || !codigoUbicacion) return;

            try {
                setIsLoading(true);

                const resp = await serverApi.post('/modulos/lista-modulos', {
                    ...query,
                    codigoEntidad,
                    sortedBy: query.sortBy,
                    sortDirection: query.sortDir,
                });

                setData(resp.data.listaModulos || []);
                setTotal(resp.data.total || 0);

            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        };

        load();
    }, [query, usuario]);

    useEffect(() => {

        if (!socket) return;


        const handler = (lista) => {
            setData(Array.isArray(lista?.listaModulos) ? lista.listaModulos : []);
            setTotal(lista?.total || 0);
        };

        socket.on('lista-modulos', handler);

        return () => socket.off('lista-modulos', handler);

    }, [socket])

    useEffect(() => {
        const timeout = setTimeout(() => {

            if (searchInput.trim().length > 0 && searchInput.trim().length < 2) return;

            setQuery(prev => {
                if (prev.search === searchInput) return prev; // 🔥 evita re-render

                return {
                    ...prev,
                    search: searchInput,
                    page: 1
                };
            });

        }, 1000);

        return () => clearTimeout(timeout);

    }, [searchInput]);

    const paginate = (page) => {
        if (page < 1 || page > totalPages) return;

        setQuery(prev => ({
            ...prev,
            page
        }));
    };

    const handleSortChange = (e) => {
        const [sortBy, sortDir] = e.target.value.split(':');
        setQuery(prev => ({ ...prev, sortBy, sortDir, page: 1 }));
    };



    const inactivaModulo = async (uidModulo, accion) => {

        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
        if (!codigoEntidad || codigoEntidad === null || !codigoUbicacion || codigoUbicacion === null) return sweet('Atención!', 'Revise la infromación', 'error');

        const act = accion === 1 ? "Activar" : "Inactivar";

        const confirmacion = await sweetConfirm("Atención", `Esta seguro de ${act} el registro?`, "warning").then((result) => {
            return (result);
        })

        if (!confirmacion.value) return false;

        try {

            setIsLoading(true);

            await serverApi.post(
                `/modulos/inactiva-modulo`,
                {
                    ...query,
                    uidModulo,
                    accion,
                    codigoEntidad,
                    codigoUbicacion,
                }
            );

        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }


    const registraModulo = async (datos) => {

        const codigoEntidad = localStorage.getItem("codigoEntidad");
        if (!codigoEntidad || codigoEntidad === null) return sweet('Atención!', 'Revise la infromación', 'error');

        try {

            setIsLoading(true);
            const res = await serverApi.post(
                `/modulos/registra-modulo`,
                {
                    ...query,
                    ...datos,
                    codigoEntidad,

                }
            );

            if (res.data.ok === false) {
                sweet('', res.data.resp, 'error');
            } else {
                sweet('', res.data.resp, 'success');
                setShowModal(false)
            }


        } catch (error) {
            // sweet('Atención!', res[1], 'error');
            console.error(error);
        } finally {
            setIsLoading(false);

        }


    }

    // Actualiza un campo del módulo (nombre o recibe traslados) con actualización optimista
    const editaModulo = async (campo, valor, uidModulo, valorAnterior) => {

        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = usuario.codigoUbicacion;
        const codigoUbicacionEditar = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;

        if (!codigoEntidad || codigoEntidad === null || !codigoUbicacion || codigoUbicacion === null) {
            return sweet('Atención!', 'Revise la infromación', 'error');
        }

        const confirmacion = await sweetConfirm("Atención", "Esta seguro de Modificar el registro?", "warning");
        if (!confirmacion.value) return false;

        const valorOptimista = campo === 'recibeTraslados' ? (valor ? 1 : 0) : valor;
        const valorRevertir = campo === 'recibeTraslados' ? (valorAnterior ? 1 : 0) : valorAnterior;

        const aplicarValor = (v) => setData(prev =>
            prev.map(item =>
                item.uidModulo === uidModulo
                    ? { ...item, [campo]: v }
                    : item
            )
        );

        // Actualización optimista del estado local
        aplicarValor(valorOptimista);

        try {

            setIsLoading(true);

            const res = await serverApi.post(
                `/modulos/edita-modulo`,
                {
                    ...query,
                    campo,
                    valor,
                    uidModulo,
                    codigoEntidad,
                    codigoUbicacion,
                    codigoUbicacionEditar
                }
            );

            const r = res.data?.resp;
            if (Array.isArray(r) && (r[0] === '' || r[0] === 'E')) {
                aplicarValor(valorRevertir);
                sweet('', r[1] || 'No fue posible modificar el registro', 'error');
            }

        } catch (error) {
            console.error(error);
            aplicarValor(valorRevertir);
        } finally {
            setIsLoading(false);

        }

    }

    const iniciarEdicionNombre = (item) => {
        setEditingUid(item.uidModulo);
        setEditingNombre((item.modulo || '').toUpperCase());
    };

    const guardarNombreModulo = async (item) => {
        const nuevo = editingNombre.trim().toUpperCase();
        const anterior = (item.modulo || '').toUpperCase();

        setEditingUid(null);

        if (!nuevo || nuevo === anterior) return;

        await editaModulo('modulo', nuevo, item.uidModulo, item.modulo);
    };

    const sedeSeleccionada = ubicaciones.find(u => u.value === query.ideUbicacion);
    const nombreSede = (query.nombreUbicacion || sedeSeleccionada?.label || '').toUpperCase();


    if (usuario.uidUsuario === null) {
        return (
            <>
            </>
        )
    }
    else if (!pantallas.includes("creacionescritorios")) {
        return (<NoAcceso />)
    }
    else {

        return (
            <>
                {isLoading && <LoadingOverlay />}
                <div className={`content ${isLoading ? 'opacity' : ''}`} style={{ padding: '0 24px 24px', fontFamily: "'Inter', Arial, sans-serif" }}>

                    <div style={{ maxWidth: 1320, margin: '0 auto' }}>

                        <div style={{
                            background: 'white', borderRadius: 16, overflow: 'hidden',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0',
                        }}>

                            {/* Header de la card */}
                            <div style={{
                                padding: '20px 26px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0',
                                display: 'flex', flexWrap: 'wrap', gap: 14, justifyContent: 'space-between', alignItems: 'center',
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                                    <div style={{
                                        width: 46, height: 46, borderRadius: 14,
                                        background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-secundario) 100%)',
                                        color: 'var(--color-marca-contraste)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        fontSize: 20, boxShadow: '0 4px 14px rgba(var(--color-primario-rgb),0.3)',
                                    }}>
                                        <i className="fa-solid fa-cubes"></i>
                                    </div>
                                    <div>
                                        <h4 style={{ margin: 0, fontWeight: 800, fontSize: 18, color: '#0f172a' }}>Módulos</h4>
                                        <p style={{ margin: '2px 0 0', fontSize: 12.5, color: '#64748b' }}>
                                            Administra los módulos por sede / ubicación y clase
                                        </p>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                                    <span style={{
                                        background: '#ecfdf5',
                                        color: '#047857',
                                        fontWeight: 800, padding: '6px 14px', borderRadius: 12, fontSize: 13,
                                        display: 'inline-flex', alignItems: 'center', gap: 7,
                                    }}>
                                        <i className="fa-solid fa-location-dot"></i>
                                        {nombreSede || 'Sede no definida'}
                                    </span>

                                    <button
                                        onClick={() => setShowClasesModal(true)}
                                        title="Crear y gestionar las clases de módulo"
                                        style={{
                                            padding: '11px 18px', borderRadius: 12, border: '1.5px solid var(--color-primario-borde)',
                                            background: 'var(--color-primario-suave)', color: 'var(--color-primario-texto)', fontWeight: 800, cursor: 'pointer', fontSize: 13.5,
                                            display: 'inline-flex', alignItems: 'center', gap: 8,
                                        }}
                                    >
                                        <i className="fa-solid fa-tags"></i> Crear clase de módulo
                                    </button>

                                    <button
                                        onClick={() => setShowModal(true)}
                                        style={{
                                            padding: '11px 20px', borderRadius: 12, border: 'none',
                                            background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-secundario) 100%)',
                                            color: 'var(--color-marca-contraste)', fontWeight: 800, cursor: 'pointer', fontSize: 13.5,
                                            boxShadow: '0 4px 14px rgba(var(--color-primario-rgb),0.3)',
                                            display: 'inline-flex', alignItems: 'center', gap: 8,
                                        }}
                                    >
                                        <i className="fa-solid fa-plus"></i> Crear módulo
                                    </button>
                                </div>
                            </div>

                            {/* Barra de herramientas */}
                            <div style={{
                                padding: '16px 26px', borderBottom: '1px solid #f1f5f9',
                                display: 'flex', flexWrap: 'wrap', gap: 14, alignItems: 'flex-end', justifyContent: 'space-between',
                            }}>
                                <div style={{ position: 'relative', flex: 1, maxWidth: 420, minWidth: 220 }}>
                                    <i className="fa-solid fa-magnifying-glass" style={{
                                        position: 'absolute', left: 13, top: '50%', transform: 'translateY(-50%)',
                                        color: '#94a3b8', fontSize: 13,
                                    }} />
                                    <input
                                        type='text'
                                        placeholder='Buscar por módulo o clase...'
                                        maxLength={20}
                                        value={searchInput}
                                        onChange={(ev) => setSearchInput(ev.target.value)}
                                        style={{
                                            width: '100%', padding: '10px 12px 10px 38px', borderRadius: 10,
                                            border: '1.5px solid #e2e8f0', fontSize: 13.5, outline: 'none',
                                            background: '#f8fafc', transition: 'border-color .15s, background .15s',
                                        }}
                                        onFocus={(e) => { e.target.style.borderColor = 'var(--color-primario)'; e.target.style.background = '#ffffff'; }}
                                        onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.background = '#f8fafc'; }}
                                    />
                                </div>

                                <div style={{ width: 320, maxWidth: '100%' }}>
                                    <label style={{ fontSize: 12, fontWeight: 700, color: '#475569', display: 'block', marginBottom: 6 }}>
                                        Sede / Ubicación
                                    </label>
                                    <SelectElement
                                        options={ubicaciones}
                                        name={`idUbicacion`}
                                        isMulti={false}
                                        closeOnMenuSelect={true}
                                        value={ubicaciones.find(u => u.value === query.ideUbicacion)}
                                        onChange={(selected) => handleSelectUbicacion(selected)}
                                        classname=""
                                        isClearable={false}
                                        fontSize="13.5px"
                                    />
                                </div>

                                <div style={{ width: 210, maxWidth: '100%' }}>
                                    <label style={{ fontSize: 12, fontWeight: 700, color: '#475569', display: 'block', marginBottom: 6 }}>
                                        Ordenar por
                                    </label>
                                    <SelectBuscable
                                        name="sort"
                                        asEvent
                                        onChange={handleSortChange}
                                        isClearable={false}
                                        options={[
                                            { value: 'modulo:asc', label: 'Módulo (A–Z)' },
                                            { value: 'modulo:desc', label: 'Módulo (Z–A)' },
                                            { value: 'moduloClase:asc', label: 'Clase (A–Z)' },
                                            { value: 'moduloClase:desc', label: 'Clase (Z–A)' },
                                            { value: 'nombreUbicacion:asc', label: 'Ubicación (A–Z)' },
                                            { value: 'nombreUbicacion:desc', label: 'Ubicación (Z–A)' },
                                        ]}
                                        value={`${query.sortBy}:${query.sortDir}`}
                                        fontSize="13.5px"
                                    />
                                </div>
                            </div>

                            {/* Lista de módulos */}
                            <div style={{ padding: '18px 26px', background: '#f8fafc' }}>
                                {data.length === 0 ? (
                                    <div style={{ padding: '48px 20px', textAlign: 'center' }}>
                                        <div style={{ color: '#94a3b8', fontSize: 34, marginBottom: 8 }}>
                                            <i className="fa-solid fa-cubes"></i>
                                        </div>
                                        <div style={{ fontWeight: 700, color: '#64748b', fontSize: 15 }}>
                                            No hay módulos registrados
                                        </div>
                                        <div style={{ color: '#94a3b8', fontSize: 13, marginTop: 4 }}>
                                            Crea el primer módulo para esta sede.
                                        </div>
                                    </div>
                                ) : (
                                    data.map((item) => {
                                        const activo = item.indActivo === 1;
                                        const recibeTraslados = Number(item.recibeTraslados) === 1;
                                        const editando = editingUid === item.uidModulo;
                                        return (
                                            <div
                                                key={item.uidModulo}
                                                style={{
                                                    background: '#ffffff', borderRadius: 14,
                                                    border: `1.5px solid ${activo ? '#e2e8f0' : '#fecaca'}`,
                                                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)', padding: '16px 18px', marginBottom: 12,
                                                    display: 'flex', flexWrap: 'wrap', gap: 14,
                                                    alignItems: 'center', justifyContent: 'space-between',
                                                    opacity: activo ? 1 : 0.72,
                                                    transition: 'box-shadow .15s, border-color .15s',
                                                }}
                                                onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 6px 16px rgba(var(--color-primario-rgb),0.12)'; e.currentTarget.style.borderColor = 'var(--color-primario)'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)'; e.currentTarget.style.borderColor = activo ? '#e2e8f0' : '#fecaca'; }}
                                            >
                                                {/* Icono + nombre */}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 220, flex: '1 1 260px' }}>
                                                    <div style={{
                                                        width: 46, height: 46, borderRadius: 12, flexShrink: 0,
                                                        background: activo ? 'rgba(var(--color-primario-rgb), 0.12)' : '#f1f5f9',
                                                        border: '1.5px solid #e2e8f0',
                                                        color: activo ? 'var(--color-primario)' : '#94a3b8',
                                                        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20,
                                                    }}>
                                                        <i className="fa-solid fa-cube"></i>
                                                    </div>
                                                    <div style={{ minWidth: 0, flex: 1 }}>
                                                        <div style={{ fontWeight: 800, color: '#0f172a', fontSize: 14.5, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                                                            {editando ? (
                                                                <input
                                                                    type='text'
                                                                    autoFocus
                                                                    value={editingNombre}
                                                                    maxLength={20}
                                                                    onChange={(ev) => setEditingNombre(ev.target.value.toUpperCase())}
                                                                    onBlur={() => guardarNombreModulo(item)}
                                                                    onKeyDown={(ev) => {
                                                                        if (ev.key === 'Enter') guardarNombreModulo(item);
                                                                        if (ev.key === 'Escape') setEditingUid(null);
                                                                    }}
                                                                    style={{
                                                                        padding: '4px 10px', borderRadius: 8,
                                                                        border: '1.5px solid var(--color-primario)', fontSize: 14, outline: 'none',
                                                                        fontWeight: 800, textTransform: 'uppercase', maxWidth: 220,
                                                                    }}
                                                                />
                                                            ) : (
                                                                <>
                                                                    {(item.modulo || '').toUpperCase()}
                                                                    {item.moduloClase && (
                                                                        <span style={{
                                                                            background: '#e2e8f0', color: '#334155', fontWeight: 800,
                                                                            padding: '2px 9px', borderRadius: 999, fontSize: 11,
                                                                        }}>
                                                                            {(item.moduloClase || '').toUpperCase()}
                                                                        </span>
                                                                    )}
                                                                </>
                                                            )}
                                                            {!activo && (
                                                                <span className="badge" style={{ background: '#fee2e2', color: '#b91c1c', fontWeight: 800, padding: '4px 10px', borderRadius: 999, fontSize: 11 }}>
                                                                    INACTIVO
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div style={{ color: '#64748b', fontSize: 12.5, marginTop: 2, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', maxWidth: 320 }}>
                                                            {(item.nombreUbicacion || '').toUpperCase()}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Chips de información */}
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', flex: '1 1 400px' }}>
                                                    <span style={chipStyle}>
                                                        Clase: <b style={{ color: '#0f172a' }}>{(item.moduloClase || '').toUpperCase()}</b>
                                                    </span>
                                                    <span style={chipStyle}>
                                                        Ubicación: <b style={{ color: '#0f172a' }}>{(item.nombreUbicacion || '').toUpperCase()}</b>
                                                    </span>
                                                    <span style={recibeTraslados ? { ...chipStyle, ...chipOk } : { ...chipStyle, ...chipNo }}>
                                                        {recibeTraslados ? <i className="fa-solid fa-check"></i> : null}
                                                        Traslado: {recibeTraslados ? 'Sí' : 'No'}
                                                    </span>
                                                </div>

                                                {/* Acciones */}
                                                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                                    <button
                                                        title="Editar nombre"
                                                        style={botonAccion('var(--color-secundario-suave)', 'var(--color-primario)')}
                                                        onClick={() => iniciarEdicionNombre(item)}
                                                        disabled={!activo}
                                                    >
                                                        <i className="fa-solid fa-pen"></i>
                                                    </button>

                                                    <label
                                                        title="Recibe traslados"
                                                        style={{
                                                            display: 'inline-flex', alignItems: 'center', gap: 6,
                                                            background: recibeTraslados ? '#d1fae5' : '#e2e8f0',
                                                            color: recibeTraslados ? '#047857' : '#64748b',
                                                            padding: '5px 10px', borderRadius: 9, cursor: 'pointer',
                                                            fontSize: 11.5, fontWeight: 800,
                                                        }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input m-0"
                                                            checked={recibeTraslados}
                                                            disabled={!activo}
                                                            onChange={(ev) => editaModulo('recibeTraslados', ev.target.checked, item.uidModulo, item.recibeTraslados)}
                                                            style={{ accentColor: 'var(--color-primario)', cursor: 'pointer' }}
                                                        />
                                                        <i className="fa-solid fa-right-left"></i> Traslado
                                                    </label>

                                                    {activo ? (
                                                        <button
                                                            title="Inactivar"
                                                            style={botonAccion('#fee2e2', '#b91c1c')}
                                                            onClick={() => inactivaModulo(item.uidModulo, 0)}
                                                        >
                                                            <i className="fa-solid fa-ban"></i>
                                                        </button>
                                                    ) : (
                                                        <button
                                                            title="Activar"
                                                            style={botonAccion('#d1fae5', '#047857')}
                                                            onClick={() => inactivaModulo(item.uidModulo, 1)}
                                                        >
                                                            <i className="fa-solid fa-check"></i>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })
                                )}
                            </div>

                            {/* Paginación */}
                            <div style={{
                                padding: '14px 26px', borderTop: '1px solid #f1f5f9',
                                background: '#f8fafc', display: 'flex', flexWrap: 'wrap', gap: 10,
                                justifyContent: 'space-between', alignItems: 'center',
                            }}>
                                <span style={{ color: '#64748b', fontSize: 13 }}>
                                    Registros: <b style={{ color: '#0f172a' }}>{total}</b>
                                </span>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <span style={{ fontSize: 13, color: '#475569' }}>
                                        Página {query.page} de {totalPages}
                                    </span>
                                    <button
                                        onClick={() => paginate(query.page - 1)}
                                        disabled={query.page === 1}
                                        style={{ ...paginacionBtn, opacity: query.page === 1 ? 0.4 : 1 }}
                                    >
                                        <i className="fa-solid fa-chevron-left"></i>
                                    </button>
                                    <button
                                        onClick={() => paginate(query.page + 1)}
                                        disabled={query.page >= totalPages}
                                        style={{ ...paginacionBtn, opacity: query.page >= totalPages ? 0.4 : 1 }}
                                    >
                                        <i className="fa-solid fa-chevron-right"></i>
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <CrearModuloModal
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    ubicaciones={ubicaciones}
                    onSave={(data) => {
                        registraModulo(data)

                    }}
                />

                <GestionarModuloClasesModal
                    show={showClasesModal}
                    onClose={() => setShowClasesModal(false)}
                />
            </>
        )
    }
}
